import * as Sentry from '@sentry/react';
import type { BrowserOptions } from '@sentry/react';
import { scrubEvent, scrubBreadcrumb, scrubLogAttributes } from './utils/piiScrubber';

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || import.meta.env.MODE,
  enabled: !!import.meta.env.VITE_SENTRY_DSN,
  tracesSampleRate: 1,
  enableLogs: true,
  tracePropagationTargets: [/^https:\/\/voice-quote-api/, /^http:\/\/localhost:8787/],
  integrations: [Sentry.browserTracingIntegration()],
  beforeSend: scrubEvent as BrowserOptions['beforeSend'],
  beforeBreadcrumb: scrubBreadcrumb,
  beforeSendLog: scrubLogAttributes,
});

export default Sentry;
